import GermanIcon from '@assets/images/Flag_of_Germany.svg';
import BritainIcon from '@assets/images/Flag_of_the_United_Kingdom.svg';
import HeaderChip from '@components/HeaderChip.jsx';
import { useTranslation } from 'react-i18next';

//language setting component
function LanguageSelect() {
    const { i18n } = useTranslation();

    async function handleChangeLng(lng) {
        await i18n.changeLanguage(lng);
        //window.location.reload();
    }

    const currentLang = i18n.resolvedLanguage;
    const imgSrc = currentLang === 'de' ? BritainIcon : GermanIcon;

    return (
        <HeaderChip
            tooltip={
                currentLang === 'de' ? 'Sprache ändern zu Englisch' : 'Change language to german'
            }
            imgSrc={imgSrc}
            onClick={() => handleChangeLng(currentLang === 'de' ? 'en' : 'de')}
        />
    );
}

export default LanguageSelect;
